export const GET_CATEGORIES_REQUEST = 'GET_CATEGORIES_REQUEST'

// The action for sending asynchronous request for categories to the server
// (some splash screens can be shown in future)
export const requestCategories = () => {
  return {
    type: GET_CATEGORIES_REQUEST
  }
}

export const GET_CATEGORIES_RESPONSE = 'GET_CATEGORIES_RESPONSE'

// The action that is dispatched when the response with
// categories is received from the server
export const receiveCategories = (json) => {
  return {
    type: GET_CATEGORIES_RESPONSE,
    categories: json
  }
}

export const CATEGORY_CHECKED = 'CATEGORY_CHECKED'

// The action that is dispatched when the some category was checked/unchecked in the filter
export const categoryChecked = (id) => {
  return {
    type: CATEGORY_CHECKED,
    categoryId: id
  }
}

export const SEARCH = 'SEARCH'

// The action that is dispatched when the user types any text in the search text box
export const search = (text) => {
  return {
    type: SEARCH,
    text: text
  }
}

// Thunk that makes an asynchronous loading categories from the server and
// dispatches corresponding "Request" and "Response" actions.
// Accepts the locale name to specify the language of the categories fetched.
export const fetchCategories = locale => dispatch => {
  dispatch(requestCategories())

  return fetch(process.env.REACT_APP_BASE_URL + `/index/categories?locale=${locale}`,
    {
      headers: { 'Content-Type': 'application/json; charset=utf-8' }
    })
    .then(
      response => response.json(),
      error => console.log('An error occurred.', error)
    )
    .then(json =>
      dispatch(receiveCategories(json))
    )
}
